module.exports = __webpack_public_path__ + "static/img/nrhc.978a279.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/nrhc.png
// module id = lhf/
// module chunks = 1